import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export default api;

// ---- Work order helpers (no pricing) ----
export const workOrderProgress = (wo) => {
  const labor = wo.labor_items || [];
  const parts = wo.parts_items || [];
  const laborDone = labor.filter((l) => l.done).length;
  const partsReceived = parts.filter(
    (p) => ((p?.status || "").toLowerCase() === "received") || (!p?.status && p?.ordered)
  ).length;
  const total = labor.length + parts.length;
  const done = laborDone + partsReceived;
  const pct = total === 0 ? 0 : Math.round((done / total) * 100);
  return {
    total,
    done,
    pct,
    laborDone,
    laborTotal: labor.length,
    partsOrdered: partsReceived,
    partsTotal: parts.length,
  };
};

export const STATUS_META = {
  new: { label: "New", cls: "bg-[#EAF0F4] text-[#3D5A6C] border border-[#B8CEDA]" },
  in_progress: {
    label: "In Progress",
    cls: "bg-[#FCF5E8] text-[#8B6914] border border-[#EBD9A8]",
  },
  ready: {
    label: "Ready",
    cls: "bg-[#EAF4F0] text-[#2F6B4F] border border-[#B5D9C7]",
  },
  completed: {
    label: "Completed",
    cls: "bg-[#F3F2EE] text-[#3D405B] border border-[#D6D3CB]",
  },
};

export const PART_STATUS_META = {
  pending: {
    label: "Pending",
    cls: "bg-[#FCF5E8] text-[#8B6914] border border-[#EBD9A8]",
  },
  order_placed: {
    label: "Order Placed",
    cls: "bg-[#EAF0F4] text-[#3D5A6C] border border-[#B8CEDA]",
  },
  received: {
    label: "Received",
    cls: "bg-[#EAF4F0] text-[#2F6B4F] border border-[#B5D9C7]",
  },
};

export const PART_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "order_placed", label: "Order Placed" },
  { value: "received", label: "Received" },
];

export const derivePartStatus = (p) => {
  const s = (p?.status || "").toLowerCase();
  if (["pending", "order_placed", "received"].includes(s)) return s;
  return p?.ordered ? "received" : "pending";
};
